<template>
  <div>
    <CCard class="mob-pd-0px">
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <CRow class="flex-flow-column">
          <CCol>
            <strong>{{ $t("scheduleAll.title") }}</strong>
          </CCol>

          <p class="desc">{{ $t("scheduleAll.desc") }}</p>
        </CRow>
        <CButton
          @click="navigateToNewSchedule(null)"
          size="sm"
          color="success"
          class="ml-auto btn-lit-blue mob-w100"
        >{{ $t("scheduleAll.addFlightSchedule") }}</CButton>
        <div class="generate-ex-btn ml-2" @click="toggleJsonExcelModal" v-if="lsFlightSchedule.length>0">
          <img src="@imgPath/img/svg/icons/excle-icon.svg" alt />
        </div>
      </CCardHeader>

      <CCardBody class="user-manage-table pt-0px">
        <br>
          <div class="d-flex"  v-if="GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode">
          <h3>{{$t("contract.contractName")+' : '}}</h3>  <h3 class="text-transform-uppercase"> {{GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode}}</h3>
           </div>
        <CCol id="user-manage-table" class="usersTable border-grey manage-user-table p-0 ml-0 ScheduleAll-table">
            <cTable
              :fields="lsFlightScheduleFields"
              :items="lsFlightSchedule"
              caption="User"
              pagination
              column-filter
              items-per-page-select
              :items-per-page="flightScheduleTableWatchList.itemsPerPage"
              hover
              :sorter="{  resetable: true }"
                      :loading="isLoading"

              class="table-striped"
              :sorterValue="{ column: 'from', asc: 'true' }"
              @filtered-items-change="getFilteredFlightScheCount"
              @page-change="onPageChange"
              @pagination-change="onPaginationChange"
                  :tableWatchList="flightScheduleTableWatchList"
             @getFields="onSaveColumns"
             :manageColumn="true"
                                    :paginationLenOption="true"
            >
         
              <template #depcode="{item}">
                <td class="py-2">
                  <div>{{ item.depcode?item.depcode:'' }}</div>
                </td>
              </template>
              <template #arrcode="{item}">
                <td class="py-2">
                  <div>{{ item.arrcode?item.arrcode:'' }}</div>
                </td>
              </template>
              <template #airline_code="{item}">
                <td class="py-2">
                  <div>{{ item.airline_code?item.airline_code:'' }}</div>
                </td>
              </template>
              <template #flight_number="{item}">
                <td class="py-2">
                  <div>{{ item.flight_number?item.flight_number:'' }}</div>
                </td>
              </template>
              <template #via_airport_code="{item}">
                <td class="py-2">
                  <div>{{ item.via_airport_code?item.via_airport_code:'' }}</div>
                </td>
              </template>
              <template #aircraft_type="{item}">
                <td class="py-2">
                  <div>{{ item.aircraft_type?item.aircraft_type:'' }}</div>
                </td>
              </template>
              <template #deptime="{item}">
                <td class="py-2">
                  <div>{{ item.deptime?item.deptime:'' }}</div>
                </td>
              </template>
              <template #arrtime="{item}">
                <td class="py-2">
                  <div>{{ item.arrtime?item.arrtime:'' }}</div>
                </td>
              </template>

              <template #no-items-view>
                <div class="text-center my-5">
                  <h2>{{isLoading?'':$t("scheduleAll.noSchedulesFound") }}</h2>
                </div>
              </template>

              <template #actions="{item}">
                <td class="py-2 filled-icon-wrap">
                  <div class="row align-center justify-content-center">


                  <!-- <div class="col-md-4 col-sm-4 col-xs-4"
                    @click.stop="showChangeStatusModal(item)"

                  >
                    <div v-c-tooltip.hover="{ content:item.status==0?$t('scheduleAll.deactivatedTooltip'):item.status==2?$t('scheduleAll.pauseSellingToolip'):item.status==1?$t('scheduleAll.activeTooltip'):'', active:false }" class="w-100">
                       <img src="~@imgPath/img/svg/icons/active.svg" alt="" height="20px" v-if="item.status==1">
                      <img src="~@imgPath/img/svg/icons/play-circle.svg" alt="" height="20px" v-if="item.status==0">
                      <img src="~@imgPath/img/svg/icons/pause-circle.svg" alt="" height="20px" v-else-if="item.status==2">
                    </div>



                  </div> -->
                  <div  @click.stop="navigateToNewSchedule(item)"
                        v-if="permission&&permission.canEdit"
                        class="edit-icon"
                        color="info removewrap col-md-4 col-sm-4 col-xs-4"

                  >
                    <div v-c-tooltip.hover="{ content: $t('scheduleAll.editTooltip') , active:false }">
                      <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="512pt"
                              viewBox="0 0 512 512"
                              width="512pt"
                              style="fill:#3c4b64;"
                      >
                        <path
                                d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                        />
                        <path
                                d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                        />
                        <path
                                d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                        />
                      </svg>
                    </div>

                  </div>

                  <div
                          v-if="permission&&permission.canDelete"
                          @click.stop="showDeleteScheduleModal(item)"
                          class="c-red col-md-4 col-sm-4 col-xs-4"

                  >
                    <div v-c-tooltip.hover="{ content:  $t('scheduleAll.deleteTooltip') , active:false }">
                      <CIcon color="#cd0606" name="cil-trash" size="lg" />
                    </div>

                  </div>
                  </div>
                </td>
              </template>
            </cTable>
          
        </CCol>
        <div class="">
          <CAlert v-if="alertValue" show color="danger" class="d-flex">
            <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')" class="d-flex ">
              <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
            </div>
            <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')" class="ml-10px ">
              <span>{{$t("cAlert.errorCode")+' : '}}</span>
              <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
            </div>
            <div v-if="alertValue&&alertValue.constructor==String" class="ml-10px ">
              <p>{{alertValue}}</p>
            </div>
          </CAlert>
        </div>
      </CCardBody>
      <CCardFooter class="d-flex justify-content-end">
        <CButton
                @click="navigateToContract"
                size="sm"
                color="danger"
                class="action-c-btn "
        >{{ $t("scheduleAll.goBack") }}</CButton>
      </CCardFooter>
    </CCard>

    <cAlertModal
      v-if="isChangeStsConfirmation"
      :buttonList="[{
              name:$t('scheduleAll.noBtn'),func:onHideConfirmationModals,color:'danger'},
                {name:$t('scheduleAll.yesBtn'),func:onChangeFlightSchedule,color:'success'},]"
      :status="2"
      :show="isChangeStsConfirmation"
      :desc="getDescForStatusChangeAlert()"
    ></cAlertModal>
    <cAlertModal
      v-if="isDeleteSchConfirmation"
      :buttonList="[{
              name:$t('scheduleAll.noBtn'),func:onHideConfirmationModals,color:'danger'},
                {name:$t('scheduleAll.yesBtn'),func:onDeleteSchedule,color:'success'},]"
      :status="2"
      :show="isDeleteSchConfirmation"
      :desc="$t('scheduleAll.deleteScheduleConfirmation')"
    ></cAlertModal>
    <cAlertModal
      v-if="isStatusChanged"
      :buttonList="[{name:$t('scheduleAll.okBtn'),func:onHideConfirmationModals,color:'success'}]"
      :status="1"
      :show="isStatusChanged"
      :desc="$t('scheduleAll.statusChangeSuccDesc')"
    ></cAlertModal>
    <cAlertModal
      v-if="isScheduleDeleted"
      :buttonList="[{name:$t('scheduleAll.okBtn'),func:onHideConfirmationModals,color:'success'}]"
      :status="1"
      :show="isScheduleDeleted"
      :desc="$t('scheduleAll.deleteScheduleSuccDesc')"
    ></cAlertModal>
    <cAlertModal
      v-if="isFailedModal"
      :buttonList="[{name:$t('scheduleAll.okBtn'),func:onHideConfirmationModals,color:'danger'}]"
      :status="0"
      :show="isFailedModal"
      :desc="alertValue"
    ></cAlertModal>

    <cJsonExcelModal
      v-if="showJsonExcelModal "
      :show="showJsonExcelModal"
      :desc="$t('jsonExcelModal.desc', { name: $t('scheduleAll.flightSchedules') })"
      :onCancel="toggleJsonExcelModal"
    >
      <template #jsonExcel>
        <div @click="toggleJsonExcelModal()">
          <cExportExcel
            :data="getPrintStatements()"
            :fields="getJsonExcelFields()"
            worksheet="Statements"
            :name="'FlightSchedule.xlsx'"
          >
          
            {{ $t("scheduleAll.download") }}
            
            </cExportExcel>
        </div>
      </template>
    </cJsonExcelModal>
  </div>
</template>

<script>
import router, { navigate } from "../../../../router/index";
import cAlertModal from "../../../../components/form/cAlertModal";

import { mapGetters, mapActions } from "vuex";
import {
  PATHNAME,
  COMPONENT_NAME,
  DEFAULT_DROPDOWN_STATUS,
  ORDER,
  FLIGHT_SCHEDULE_STATUS
} from "../../../../util/constants";
import Logger from "../../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../../../config/API_DATA";

import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneData
} from "../../../../util/util";
import BaseConfiguration from "../../../../config/base.js";
import apiGetFlightSchedule from "../../../../services/apiGetFlightSchedule";
import apiChangeFlightScheduleStatus from "../../../../services/apiChangeFlightScheduleStatus";
import apiDeleteFlightSchedule from "../../../../services/apiDeleteFlightSchedule";

// import cPaginationLenOption from "../../../../components/dataTable/cPaginationLenOption";
import cJsonExcelModal from "../../../../components/modal/cJsonExcelModal";
import cExportExcel from'./../../../../components/excel/cExportExcel'
// import cManageColumns from "./../../../../components/dataTable/cManageColumns";
import cTable from "../../../../components/dataTable/cTable";

export default {
  name: COMPONENT_NAME.SCHEDULE_ALL,
  components: {
    cAlertModal,
    cJsonExcelModal,
    cExportExcel,
    cTable
  },

  data: () => {
    return {
      alertValue: null,

      lsFlightSchedule: [],
      permission: null,
      flightScheduleTableWatchList: {
        filteredlistCount: null,
        itemsPerPage: 25,
        currentPageNum: 1
      },
      isChangeStsConfirmation: false,
      isStatusChanged: false,
      isDeleteSchConfirmation: false,
      selectedFlightSchedule: null,
      isFailedModal: false,
      isScheduleDeleted: false,
      showJsonExcelModal: false,
      isLoading:true,
      lsFlightScheduleFields:null
    };
  },

  methods: {
     ...mapActions("sFlightSchedule", {

                SET_SEL_FLIGHT_SCHEDULE: "SET_SEL_FLIGHT_SCHEDULE"
            }),            
  
    getDescForStatusChangeAlert() {
          let retValue='';

        try {
          if(BaseConfiguration.isDebug) console.log("getDescForStatusChangeAlert");
        
         if(this.selectedFlightSchedule){
            if(this.selectedFlightSchedule.status==FLIGHT_SCHEDULE_STATUS.DEACTIVATED){
           retValue=this.$t('scheduleAll.changeStatusToPauseSellingConfirm');
         }else if(this.selectedFlightSchedule.status==FLIGHT_SCHEDULE_STATUS.PAUSE_SELLING){
           retValue=this.$t('scheduleAll.changeStatustoDeactiveConfirm');
         }else if(this.selectedFlightSchedule.status==FLIGHT_SCHEDULE_STATUS.ACTIVE){
           retValue=this.$t('scheduleAll.changeStatusActiveToDeactiveConfirm');

         }
         }
        
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.SCHEDULE_ALL,
                  "error in getDescForStatusChangeAlert",
                  err.toString(),
                  "getDescForStatusChangeAlert",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
  onSaveColumns(pFields) {
    try {
      if(BaseConfiguration.isDebug) console.log("onSaveColumns");
      this.lsFlightScheduleFields=pFields;
      

    } catch (err) {
            let body = Logger.buildRequest(
             COMPONENT_NAME.SCHEDULE_ALL,
              "error in onSaveColumns",
              err.toString(),
              "onSaveColumns",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 
            // getTotalPages() {
            //     let retValue;
            //     try {
            //         if (BaseConfiguration.isDebug) console.log("getTotalPages");
            //         if (this.flightScheduleTableWatchList.filteredlistCount != null) {
            //             let totalPages = this.flightScheduleTableWatchList.filteredlistCount / this.flightScheduleTableWatchList.itemsPerPage;
            //             retValue = Math.ceil(totalPages);


            //             if (retValue <= 0) {
            //                 retValue = 1;
            //             }
            //         } else {
            //             retValue = 1;
            //         }


            //     } catch (err) {
            //         let body = Logger.buildRequest(
            //             FILE_NAME.C_AGENT_DEPOSIT,
            //             "error in getTotalPages",
            //             err.toString(),
            //             "getTotalPages",
            //             LOG_TYPE.ERROR
            //         );
            //         Logger.getResponse(body);
            //     }
            //     return retValue;
            // },

             navigateToNewSchedule(pItem) {
      try {
      if (BaseConfiguration.isDebug) console.log("navigateToNewSchedule");
      this.SET_SEL_FLIGHT_SCHEDULE(pItem);
        navigate(PATHNAME.SCHEDULE_NEW);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in navigateToNewSchedule",
          err.toString(),
          "navigateToNewSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
             navigateToContract() {
      try {
      if (BaseConfiguration.isDebug) console.log("navigateToContract");
    
        navigate(PATHNAME.CONTRACT_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in navigateToContract",
          err.toString(),
          "navigateToContract",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getJsonExcelFields() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getJsonExcelFields");
        let fields = {};

        fields[this.$t("scheduleAll.from")] = "depcode";
        fields[this.$t("scheduleAll.to")] = "arrcode";

        fields[this.$t("scheduleAll.airline")] = "airline_code";
        fields[this.$t("scheduleAll.flightNumber")] = "flight_number";
        fields[this.$t("scheduleAll.via")] = "via_airport_code";
        fields[this.$t("scheduleAll.aircraftType")] = "aircraft_type";
        fields[this.$t("scheduleAll.departureTime")] = "deptime";
        fields[this.$t("scheduleAll.arrivalTime")] = "arrtime";
        fields[this.$t("scheduleAll.weeklyOrMonthly")] = "schedules";
        fields[this.$t("scheduleAll.saleableBusinessSeats")] =
          "business_seats";
        fields[this.$t("scheduleAll.saleableEconomySeats")] = "economy_seats";

        retValue = cloneData(fields);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in getJsonExcelFields",
          err.toString(),
          "getJsonExcelFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toggleJsonExcelModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleJsonExcelModal");

        this.showJsonExcelModal = !this.showJsonExcelModal;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in toggleJsonExcelModal",
          err.toString(),
          "toggleJsonExcelModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getPrintStatements() {
      let retValue = [];

      try {
        if (BaseConfiguration.isDebug) console.log("getPrintStatements");

        let lsFlightSchedule = JSON.parse(
          JSON.stringify(this.lsFlightSchedule)
        );
        // let lsPrintStatements = [];
        // for(let i=0;i<lsFlightSchedule.length;i++){

        //   lsFlightSchedule[i].via=this.$options.filters.formatDateTime(lsFlightSchedule[i].ts);

        // }

        retValue = cloneData(lsFlightSchedule);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in getPrintStatements",
          err.toString(),
          "getPrintStatements",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    showChangeStatusModal(pItem) {
      try {
        if (BaseConfiguration.isDebug) console.log("showChangeStatusModal");
        this.selectedFlightSchedule = pItem;
        this.isChangeStsConfirmation = true;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in showChangeStatusModal",
          err.toString(),
          "showChangeStatusModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    showDeleteScheduleModal(pItem) {
      try {
        if (BaseConfiguration.isDebug) console.log("showDeleteScheduleModal");
        this.selectedFlightSchedule = pItem;
        this.isDeleteSchConfirmation = true;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in showDeleteScheduleModal",
          err.toString(),
          "showDeleteScheduleModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onHideConfirmationModals() {
      try {
        if (BaseConfiguration.isDebug) console.log("onHideConfirmationModals");

        this.isChangeStsConfirmation = false;
        this.isDeleteSchConfirmation = false;
        this.isStatusChanged = false;
        this.isFailedModal = false;
        this.isScheduleDeleted = false;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in onHideConfirmationModals",
          err.toString(),
          "onHideConfirmationModals",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onPaginationChange(pItemsPerPage) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPaginationChange");
        this.flightScheduleTableWatchList.itemsPerPage = pItemsPerPage;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in onPaginationChange",
          err.toString(),
          "onPaginationChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onPageChange(pPageNum) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPageChange");
        this.flightScheduleTableWatchList.currentPageNum = pPageNum;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in onPageChange",
          err.toString(),
          "onPageChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getFilteredFlightScheCount(pFilteredItems) {
      try {
        if (BaseConfiguration.isDebug)
          console.log("getFilteredFlightScheCount");
        this.flightScheduleTableWatchList.filteredlistCount =
          pFilteredItems.length;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in getFilteredFlightScheCount",
          err.toString(),
          "getFilteredFlightScheCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getFlightScheduleFields() {
      let returnValue = [];
      try {
        let lsFields = [
          {
            key: "depcode",
            label: this.$t("scheduleAll.from"),
            isLocked:true
          },

          {
            key: "arrcode",
            label: this.$t("scheduleAll.to"),
            isLocked:true
          },

          {
            key: "airline_code",
            label: this.$t("scheduleAll.airline"),
            isLocked:false
          },

          {
            key: "flight_number",
            label: this.$t("scheduleAll.flightNumber"),
            isLocked: false
          },
          {
            key: "via_airport_code",
            label: this.$t("scheduleAll.via"),
            isLocked:false
          },
          {
            key: "aircraft_type",
            label: this.$t("scheduleAll.aircraftType"),
            isLocked:false
          },
          {
            key: "deptime",
            label: this.$t("scheduleAll.departureTime"),
            isLocked: false
          },
          {
            key: "arrtime",
            label: this.$t("scheduleAll.arrivalTime"),
            isLocked: false
          },

          {
            key: "schedules",
            label: this.$t("scheduleAll.weeklyOrMonthly"),
            isLocked: false
          },
          {
            key: "business_seats",
            label: this.$t("scheduleAll.saleableBusinessSeats"),
            isLocked: false
          },
          {
            key: "economy_seats",
            label: this.$t("scheduleAll.saleableEconomySeats"),
            isLocked: false
          },

          {
            key: "actions",
            label: this.$t("manageUser.actions"),
            sorter: false,
            filter: false,
            isLocked:true
          }
        ];

        returnValue = lsFields;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in getFlightScheduleFields",
          err.toString(),
          "getFlightScheduleFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    navToAddFlightSchedule() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToAddFlightSchedule");
        // navigate(PATHNAME.);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in navToAddFlightSchedule",
          err.toString(),
          "navToAddFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async onDeleteSchedule() {
      try {
        if (BaseConfiguration.isDebug) console.log("onDeleteSchedule");
 let scheduleId =
          this.selectedFlightSchedule && this.selectedFlightSchedule.scheduleid
            ? this.selectedFlightSchedule.scheduleid
            : null;

        this.isDeleteSchConfirmation = false;
        let isDeleted = await this.deleteFlightSchedule(scheduleId);
        if (isDeleted) {
          let lsFlightSchedule = await this.getFlightSchedule();
          if (lsFlightSchedule) {
            this.lsFlightSchedule = lsFlightSchedule;
          }
          this.isScheduleDeleted = true;
        } else {
          this.isFailedModal = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in onDeleteSchedule",
          err.toString(),
          "onDeleteSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async onChangeFlightSchedule() {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeFlightSchedule");
        let scheduleId =
          this.selectedFlightSchedule && this.selectedFlightSchedule.scheduleid
            ? this.selectedFlightSchedule.scheduleid
            : null;
            let status =null;
            if(this.selectedFlightSchedule){
              if(this.selectedFlightSchedule.status == FLIGHT_SCHEDULE_STATUS.DEACTIVATED){
                status=FLIGHT_SCHEDULE_STATUS.PAUSE_SELLING;
              }else if(this.selectedFlightSchedule.status == FLIGHT_SCHEDULE_STATUS.PAUSE_SELLING){
                status=FLIGHT_SCHEDULE_STATUS.DEACTIVATED;
              }else if(this.selectedFlightSchedule.status == FLIGHT_SCHEDULE_STATUS.ACTIVE){
                status=FLIGHT_SCHEDULE_STATUS.DEACTIVATED;
              }
            }
        // let status =
        //   this.selectedFlightSchedule && this.selectedFlightSchedule.status == 1
        //     ? 2
        //     : 1;
        this.isChangeStsConfirmation = false;

        let isStatusChanged = await this.changeFlightSchedule(
          scheduleId,
          status
        );
        if (isStatusChanged) {
          let lsFlightSchedule = await this.getFlightSchedule();
          if (lsFlightSchedule) {
            this.lsFlightSchedule = lsFlightSchedule;
          }
          this.isStatusChanged = true;
        } else {
          this.isFailedModal = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in onChangeFlightSchedule",
          err.toString(),
          "onChangeFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async changeFlightSchedule(pScheduleId, pStatus) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("changeFlightSchedule");

        let flightScheduleReq = apiChangeFlightScheduleStatus.buildRequest(
          pScheduleId,
          pStatus
        );

        if (flightScheduleReq) {
          let flightScheduleRes = await apiChangeFlightScheduleStatus.getResponse(
            flightScheduleReq
          );
          if (VALIDATE_SUCCESS_RES(flightScheduleRes)) {
                        this.alertValue=null;

            retValue = flightScheduleRes.data.data.isStatusChanged;
            // this.showAcknowledgeAlert();
          } else {
            let error = getErrorMessage(flightScheduleRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in changeFlightSchedule",
          err.toString(),
          "changeFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async deleteFlightSchedule(pScheduleId) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("deleteFlightSchedule");

        let flightScheduleReq = apiDeleteFlightSchedule.buildRequest(
          pScheduleId
        );

        if (flightScheduleReq) {
          let flightScheduleRes = await apiDeleteFlightSchedule.getResponse(
            flightScheduleReq
          );
          if (VALIDATE_SUCCESS_RES(flightScheduleRes)) {
                        this.alertValue=null;

            retValue = flightScheduleRes.data.data.isDeleted;
            // this.showAcknowledgeAlert();
          } else {
            let error = getErrorMessage(flightScheduleRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in deleteFlightSchedule",
          err.toString(),
          "deleteFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async getFlightSchedule() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getFlightSchedule");
        let contractId=this.GET_SELECTED_CONTRACT?this.GET_SELECTED_CONTRACT.contractid:null;
        let flightScheduleReq = apiGetFlightSchedule.buildRequest(contractId);

        if (flightScheduleReq) {
          let flightScheduleRes = await apiGetFlightSchedule.getResponse(
            flightScheduleReq
          );
          if (VALIDATE_SUCCESS_RES(flightScheduleRes)) {
                        this.alertValue=null;

            retValue = flightScheduleRes.data.data.FlightScheduleList;
            this.permission = flightScheduleRes.data.data.permission;
            // this.showAcknowledgeAlert();
          } else {
            let error = getErrorMessage(flightScheduleRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_ALL,
          "error in getFlightSchedule",
          err.toString(),
          "getFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toTrimSeconds(pLsFlightSchedule) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("toTrimSeconds");
          if(pLsFlightSchedule){
            for (let i = 0; i < pLsFlightSchedule.length; i++) {
              if(pLsFlightSchedule[i].deptime) {
              pLsFlightSchedule[i].deptime = pLsFlightSchedule[i].deptime.substring(0,5)  
              }
              if(pLsFlightSchedule[i].arrtime) {
              pLsFlightSchedule[i].arrtime = pLsFlightSchedule[i].arrtime.substring(0,5)  
              }
              
            }
          }
          retValue = pLsFlightSchedule;
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.SCHEDULE_ALL,
                  "error in toTrimSeconds",
                  err.toString(),
                  "toTrimSeconds",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
  },

  async created() {
    try {
      this.lsFlightScheduleFields=this.getFlightScheduleFields();
      let lsFlightSchedule = await this.getFlightSchedule();
      if (lsFlightSchedule) {
        // this.lsFlightSchedule = lsFlightSchedule;
        this.lsFlightSchedule = this.toTrimSeconds(lsFlightSchedule)
        
      }
      this.isLoading=false;
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.SCHEDULE_ALL,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
 computed: {
    ...mapGetters("sContract", {
      GET_SELECTED_CONTRACT: "GET_SELECTED_CONTRACT"
    }),
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.SCHEDULE_ALL);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>
